module.exports = __webpack_public_path__ + "img/Z86_04.ac26330e.jpg";